import {api} from './api';
import {AuthService} from './auth-service';
import {ElectionService} from './election-service';
import Variables from './variables';

const contextServices = {
  authApi: new AuthService(api),
  electionApi: new ElectionService(api),
  http: api,
  variables: Variables,
};

export default contextServices;



// WEBPACK FOOTER //
// ./src/services/index.ts